import react, { useState } from "react";
import { Modal, Alert, message } from "antd";
import { QtyRow } from "./QtyModal.style";
import { useRef } from "react";
import { useEffect } from "react";

const QtyModal = ({
  isModalOpen,
  setIsModalOpen,
  handleSelect,
  totalQty,
  pendingQty,
  packedQty,
}) => {
  const [inputQty, setInputQty] = useState(packedQty ? packedQty : pendingQty);
  const ref = useRef(null);
  const changeHandler = (e) => {
    const val = e.target.value;
    if (0 <= val && val <= totalQty) {
      setInputQty(val);
    } else {
      message.error("Enter correct Qty", 2);
    }
  };

  const submitHandler = () => {
    if (!Number.isInteger(Number(inputQty))) {
      message.error("Enter correct Qty", 2);
      return;
    }
    handleSelect({
      isEdit: true,
      quantity: Number(inputQty),
      checked: totalQty === Number(inputQty),
    });
  };

  useEffect(() => {
    ref.current.focus();
  }, []);
  return (
    <Modal
      visible={isModalOpen}
      centered
      onOk={submitHandler}
      okText="Submit"
      onCancel={() => setIsModalOpen(false)}
      okButtonProps={{ disabled: inputQty <= 0 && totalQty << inputQty }}
      closable={false}
    >
      <QtyRow>
        <div className="label">Total Quantity</div>
        <div className="number">{totalQty}</div>
      </QtyRow>
      <QtyRow>
        <div className="label">Quantity*</div>
        <input
          type="number"
          min="0"
          max={totalQty}
          onChange={changeHandler}
          value={inputQty}
          pattern="/^\d+$/"
          ref={ref}
        />
      </QtyRow>
    </Modal>
  );
};

export default QtyModal;
